import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ReportCopyComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-copy.component";
import { ReportSelectorComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-selector.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { FiscalYear, SaveReportFile, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { Observable } from "rxjs";
import { take, takeUntil } from "rxjs/operators";

@Component({
  selector: "negative-remain-of-goods-daly-report",
  templateUrl: "negative-remain-of-goods-daly-report.component.html",
  styleUrls: ["negative-remain-of-goods-daly-report.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NegativeRemainOfGoodsDalyReportComponent extends BaseFormComponent<any> {
  public apiName: string = "InventoryReview/GetNegativeRemainOfGoodsDailyReport";
  public label: string = "گزارش مانده منفی کالا به تفکیک روز";
  public filters: GridFilter[] = [];
  public gridColumns: form_control[] = [];

  constructor(__id: FormContainerModel, _tabsservice: TabularService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.tabsservice = _tabsservice;
    this._id = __id;
  }

  async ngOnInit() {
    this.ReportSelectorForm = ReportSelectorComponent;
    this.ReportCopyForm = ReportCopyComponent;
    this.reportName = "GetNegativeRemainOfGoodsDailyReport";
    this.pathPreFix = "INV";
    this.apiName = "InventoryReview/GetNegativeRemainOfGoodsDailyReport";
    this.areaName = "Inventory";
    this.loadReports();
    this.setGridColumns();
    if (this.accountService.authService.currentFiscalYear) {
      this.filters.push({
        Type: "F",
        Filed: "FiscalYearId",
        Value: this.accountService.authService.currentFiscalYear.Id,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      });
    }
    this.filters.push({
      Type: "S",
      Filed: "GoodsCode",
      Value: 0,
      Logic: "and",
      Operator: "asc",
      Skip: 0,
      Take: 0,
    });
    this.filters.push({
      Type: "S",
      Filed: "ShamsiVoucherDate",
      Value: 0,
      Logic: "and",
      Operator: "asc",
      Skip: 0,
      Take: 0,
    });
    this.filters = Object.assign([], this.filters);
    super.ngOnInit();
  }

  setGridColumns() {
    this.gridColumns.push(<any>{ label: "شعبه", modelName: "BranchTitle", name: "BranchTitle", order: 0, listVisible: true });
    this.gridColumns.push(<any>{ label: "انبار", modelName: "WarehouseTitle", name: "WarehouseTitle", order: 1, listVisible: true });
    this.gridColumns.push(<any>{ label: "تاریخ", modelName: "ShamsiVoucherDate", name: "ShamsiVoucherDate", order: 2, listVisible: true });
    this.gridColumns.push(<any>{ label: "کد کالا", modelName: "GoodsCode", name: "GoodsCode", order: 3, listVisible: true });
    this.gridColumns.push(<any>{ label: "کالا", modelName: "GoodsTitle", name: "GoodsTitle", order: 4, listVisible: true });
    this.gridColumns.push(<any>{ label: "واحد سنجش", modelName: "GoodsUnitTitle", name: "GoodsUnitTitle", order: 5, listVisible: true });
    this.gridColumns.push(<any>{
      label: "وارده",
      modelName: "InPutAmount",
      name: "InPutAmount",
      order: 6,
      listVisible: true,
      withComma: true,
      textType: "number",
    });
    this.gridColumns.push(<any>{
      label: "صادره",
      modelName: "OutPutAmount",
      name: "OutPutAmount",
      order: 7,
      listVisible: true,
      withComma: true,
      textType: "number",
    });
    this.gridColumns.push(<any>{
      label: "مانده",
      modelName: "RemainAmount",
      name: "RemainAmount",
      order: 9,
      listVisible: true,
      withComma: true,
      textType: "number",
    });
  }

  async setColumns() {
    this.columns = [];
    this.columns.push(<form_control>{
      label: "سال مالی",
      controlType: FormControlTypes.dropdown,
      modelName: "FiscalYearId",
      userClass: "small",
      disabled: false,
      name: "FiscalYearId",
      order: 1,
      textType: "text",
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Id",
      displayMember: "Year",
    });
    this.setColumnNumber(this.columns, 5);
    this.orignalColumns = this.columns;
  }

  addControl(): void {
    if (this.accountService.authService.currentFiscalYear) {
      this.setValue("FiscalYearId", this.accountService.authService.currentFiscalYear.Id);
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x: FiscalYear) => {
        if (x && x.StartDate) this.setValue("FiscalYearId", x.Id);
      });
  }

  onFormChanges(changes: FiscalYear) {
    if (changes?.Year) {
      const fiscalYearIdIndex = this.filters.findIndex((x) => x.Filed === "FiscalYearId" && x.Type === "F");
      this.filters.splice(fiscalYearIdIndex, 1, {
        Type: "F",
        Filed: "FiscalYearId",
        Value: changes.Id,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      });
      this.filters = Object.assign([], this.filters);
    }
  }

  canDeactivate(): boolean | Observable<boolean> {
    return true;
  }
}
